import React from 'react';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import logo from '../../public/static/images/logo.png';
import Button from '../Button';
import { ITUNES_APP_URL } from '../../constants';
import { useTrackingContext } from '../../hooks';

const Navbar = ({ isHomepage = false }) => {
  const router = useRouter();
  const { trackExternalLink, trackInternalLink } = useTrackingContext();

  const commonTrackingData = {
    unit_type: 'nav',
    unit_name: 'main',
    item_type: 'button',
  };

  const handleGetIslandClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    trackExternalLink({
      ...commonTrackingData,
      item_name: 'get_island',
      position_in_unit: 1,
      target_content_url: ITUNES_APP_URL,
    });

    window.open(ITUNES_APP_URL, '_blank');
  };

  const handleLogoClick = () => {
    if (!isHomepage) {
      trackInternalLink({
        ...commonTrackingData,
        item_name: 'home',
        position_in_unit: 0,
        target_content_type: 'utility',
        target_content_id: 'home',
      });

      // Navigate to homepage
      router.push('/');
    }
  };

  return (
    <div className={styles.navbar} role="banner">
      <div className={styles.logoWrapper} onClick={handleLogoClick}>
        <img className={styles.logo} src={logo} alt="Island logo" />
      </div>
      <Button
        className={styles.button}
        onClick={handleGetIslandClick}
        text="Get island"
        height={38}
        backgroundColor="#0F0"
        shadowColor="#00D900"
        color="black"
      />
    </div>
  );
};

export default Navbar;
